import * as API from '@/api'
import request from './index'

/**
 * 首页统计信息
 */
export function count(params) {
    return request.get(API.HOME_FAC_COUNT, {
        params
    })
}

/*
 * 波动图
 */
export function boCount(params) {
    return request.get(API.HOME_BO_CHART, {
        params
    })
}
